import React, { useState } from "react";
import {
  Navbar as NextNavbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  Link,
  Button,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  Avatar,
  Image,
} from "@nextui-org/react";
import useCheckAuth from "../hooks/useCheckAuth";
import { IoIosArrowDown } from "react-icons/io";
import { IoPersonSharp } from "react-icons/io5";
import TestImage from "../assets/images/avatar3.png";
import { NavLink, useLocation } from "react-router-dom";
import { BaseUrl } from "../api";
import { toast } from "react-toastify";
import { IoNotificationsOutline } from "react-icons/io5";
import NotificationDrawer from "./NotificationDrawer";

const Navbar = () => {
  const { isLoading, isLoggedIn, user } = useCheckAuth();
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState<string>("");
  const toggleDrawer = () => {
    setIsOpen((prevState) => !prevState);
  };

  const menuItems = [
    {
      key: "profile",
      label: "Profile",
      icon: IoPersonSharp,
      href: "/profile",
    },
    {
      key: "logout",
      label: "Logout",
      onClick: async () => {
        await fetch(`${BaseUrl}/logout/`, {
          method: "POST",
        })
          .then((response) => response.json())
          .then((data) => toast.success("Logged out successfully"))
          .catch((error) => console.error(error));
        localStorage.removeItem("token");
        window.location.reload();
      },
    },
  ];

  return (
    <NextNavbar className="bg-default-200">
      <NavbarBrand>
        <Image
          height={40}
          radius="sm"
          src="https://www.ppu.edu/p/sites/all/themes/ppu2018/logo.png"
          width={40}
          alt="logo"
        />
        <span className="p-2 text-lg font-semibold">CRS</span>
      </NavbarBrand>
      <NavbarContent className="hidden sm:flex gap-4" justify="center">
        <NavbarItem>
          <NavLink
            className={`${
              location.pathname === "/" && "bg-gray-300 text-blue-500 font-bold"
            } py-2 px-4 rounded-md `}
            color="foreground"
            to="/"
          >
            Home
          </NavLink>
        </NavbarItem>
        <NavbarItem>
          <NavLink
            className={`${
              location.pathname === "/courses" &&
              "bg-gray-300 text-blue-500 font-bold"
            } py-2 px-4 rounded-md `}
            color="foreground"
            to="/courses"
          >
            Courses
          </NavLink>
        </NavbarItem>
        <NavbarItem>
          <NavLink
            className={`${
              location.pathname === "/reports" &&
              "bg-gray-300 text-blue-500 font-bold"
            } py-2 px-4 rounded-md `}
            color="foreground"
            to="/reports"
          >
            Reports
          </NavLink>
        </NavbarItem>
        {user?.is_staff && (
          <NavbarItem>
            <NavLink
              className={`${
                location.pathname === "/dashboard" &&
                "bg-gray-300 text-blue-500 font-bold"
              } py-2 px-4 rounded-md `}
              color="foreground"
              to="/dashboard"
            >
              Dashboard
            </NavLink>
          </NavbarItem>
        )}
      </NavbarContent>
      <NavbarContent justify="end">
        <div className={`${isOpen ? "block" : "hidden"}`}>
          <NotificationDrawer
            notificationMessage={notificationMessage}
            setNotificationMessage={setNotificationMessage}
            isOpen={isOpen}
            toggleDrawer={toggleDrawer}
          />
        </div>
        {isLoggedIn ? (
          <NavbarItem className="flex items-center gap-5">
            <div
              onClick={toggleDrawer}
              className="p-2 bg-[#f1f1f1] rounded-full cursor-pointer relative hover:bg-[#e1e1e1] transition-all duration-300 ease-in-out"
            >
              <div className="flex items-center justify-center text-white w-5 h-5 absolute -top-1 -right-1 rounded-full bg-red-500">
                {notificationMessage && notificationMessage.length > 0 ? 1 : 0}
              </div>
              <IoNotificationsOutline size={24} />
            </div>
            <Dropdown>
              <DropdownTrigger>
                <div>
                  <div className="flex items-center gap-3 bg-default-300 dark:bg-default-200 hover:bg-default-100 dark:hover:bg-default-300 cursor-pointer px-5 py-[6px] rounded-full">
                    <Avatar alt="Profile Image" src={TestImage} />
                    <div className="flex flex-col dark:text-white">
                      <p className="font-bold text-base">{user?.username}</p>
                      <p className="text-sm">
                        {user?.email
                          ? user.email.length > 14
                            ? user.email.slice(0, 14) + "..."
                            : user.email
                          : ""}
                      </p>
                    </div>
                    <IoIosArrowDown size={20} />
                  </div>
                </div>
              </DropdownTrigger>
              <DropdownMenu aria-label="Dynamic Actions" items={menuItems}>
                {(item) => (
                  <DropdownItem
                    key={item.key}
                    color={item.key === "logout" ? "danger" : "default"}
                    href={item.href}
                    className={item.key === "logout" ? "text-danger" : ""}
                    onClick={item.onClick}
                  >
                    {item.label}
                  </DropdownItem>
                )}
              </DropdownMenu>
            </Dropdown>
          </NavbarItem>
        ) : (
          <div className="flex gap-3">
            <NavbarItem className="hidden lg:flex">
              <Button as={Link} color="primary" href="/login" variant="light">
                Login
              </Button>
            </NavbarItem>
            <NavbarItem>
              <Button as={Link} color="primary" href="/signup" variant="flat">
                Sign Up
              </Button>
            </NavbarItem>
          </div>
        )}
      </NavbarContent>
    </NextNavbar>
  );
};

export default Navbar;
